function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 11,
    viewBox: "0 0 9 11"
  }, props), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "text-before-edge",
    style: {
      fontKerning: "normal"
    },
    fill: "#001c33",
    fontFamily: "'Poppins','Poppins'",
    fontSize: 14,
    transform: "translate(0 -1)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontKerning: "normal"
    }
  }, "\xA3")));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjExIiB2aWV3Qm94PSIwIDAgOSAxMSI+CiAgICA8Zz4KICAgICAgICA8ZyBvcGFjaXR5PSIuMyI+CiAgICAgICAgICAgIDxnPjx0ZXh0IGRvbWluYW50LWJhc2VsaW5lPSJ0ZXh0LWJlZm9yZS1lZGdlIiBzdHlsZT0iZm9udC1rZXJuaW5nOm5vcm1hbCIgZmlsbD0iIzAwMWMzMyIKICAgICAgICAgICAgICAgICAgICBmb250LWZhbWlseT0iJ1BvcHBpbnMnLCdQb3BwaW5zJyIgZm9udC1zaXplPSIxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMSkiPgogICAgICAgICAgICAgICAgICAgIDx0c3BhbiBzdHlsZT0iZm9udC1rZXJuaW5nOm5vcm1hbCI+wqM8L3RzcGFuPgogICAgICAgICAgICAgICAgPC90ZXh0PjwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { Svg as ReactComponent };